import clsx from "clsx"
import { forwardRef, useContext } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

import { DialogContext } from "@molecules/Dialog/Dialog"
import type { DialogContentProps } from "@molecules/Dialog/Dialog.types"
import { PopoverContext } from "@molecules/Popover/Popover"
import { Popover } from "@molecules/index"

import styles from "./DialogContent.module.scss"

function DialogContent(props: DialogContentProps) {
    const { children, className, ...rest } = props
    const { isOpen } = useContext(PopoverContext)
    const { variant } = useContext(DialogContext)
    const isDesktop = useIsDesktop()

    return (
        <>
            {isDesktop && <Popover.Overlay isActive={isOpen} />}
            <Popover.Viewport
                className={clsx(styles.base, {
                    [styles.focused]: variant === "focused",
                })}
                {...rest}
            >
                <div className={clsx(styles.dialog, className)}>{children}</div>
            </Popover.Viewport>
        </>
    )
}

export default forwardRef(DialogContent)
